import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import { AppLayout } from './app-layout';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, hasRole } = useAuthStore();
  const location = useLocation();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-bc-teal border-t-transparent mx-auto mb-4" />
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect global admins and global readers to admin equivalents
  // When a global admin/reader visits a partner route, redirect to admin equivalent if it exists
  if (hasRole('global_admin', 'global_reader')) {
    const adminRedirects: Record<string, string> = {
      '/dashboard': '/admin/dashboard',
      '/deals': '/admin/deals',
      '/commissions': '/admin/commissions',
    };
    const adminPath = adminRedirects[location.pathname];
    if (adminPath) {
      return <Navigate to={adminPath} replace />;
    }
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
